import { render, staticRenderFns } from "./Page037.vue?vue&type=template&id=83450986&scoped=true&"
import script from "./Page037.vue?vue&type=script&lang=js&"
export * from "./Page037.vue?vue&type=script&lang=js&"
import style0 from "./Page037.vue?vue&type=style&index=0&id=83450986&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83450986",
  null
  
)

export default component.exports